import { parseDef } from "../parseDef.js";

//#region src/utils/zod-to-json-schema/parsers/catch.ts
const parseCatchDef = (def, refs) => {
	return parseDef(def.innerType._def, refs);
};

//#endregion
export { parseCatchDef };
//# sourceMappingURL=catch.js.map